import { UserApi } from '../../../api';
import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { addProfileMedicalLeaveRequestHistory } from '../../../store/slices/user-profile.slice';

const useHttpGetHistoryMedicalLeaveRequestsForUserOnMount = (
    userSub: string,
    page?: number,
    size?: number,
    sort?: string,
    direction?: 'asc' | 'desc'
) => {
    const userApi: UserApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState(false);
    const [total, setTotal] = useState<number>(0);

    const { exec, abort } = userApi.historyMedicalLeaveRequestsForUser({
        query: {
            ...(page && { page }),
            ...(size && { size }),
            ...(sort && { sort }),
            ...(direction && { direction }),
        },
        params: { userSub },
        onSuccess: res => {
            dispatch(addProfileMedicalLeaveRequestHistory(res.body.items));
            setTotal(parseInt(res.body.total));
        },
        onFinally: () => setIsReady(true),
    });

    useEffect(() => {
        exec();
        return abort;
    }, []);

    return { exec, isReady, total };
};

export default useHttpGetHistoryMedicalLeaveRequestsForUserOnMount;
